<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">LED信息群发</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="标题" prop="title">
            <el-input v-model="queryParams.title" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="ledList"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="CarName"
                label="标题"
              ></el-table-column>
              <el-table-column
                prop="CarId"
                label="LED名称"
              ></el-table-column>
              <el-table-column prop="BeginDate" label="发送时间" width="200"></el-table-column>
              <el-table-column prop="PlateNo" label="发送结果"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
// import MyApis from "../../../apis";
export default {
  name: "LedMassMessageView",
  controller: "UI",
  action: "LedMassMessageView",
  data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        title: null,
        pageNum: 1,
        pageSize: 10
      },
      // 表格数据
      ledList: []
    };
  },
  created() {
    
  },
  methods: {
    getList(){

    },
    onSearch(){
      this.queryParams.pageNum = 1;
      this.getList();
    },
    onCancel(){
      this.resetForm("queryForm");
      this.onSearch();
    },
    onAdd(){
      this.$router.push({
        path: "/plugin/led/UI/LedMassMessageInfo",
        query: { type: "add" },
      });
    },
    queryDetail(row){
      this.$router.push({
        path: "/plugin/led/UI/LedMassMessageInfo",
        query: { id: row.id, type: "query" },
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.search();
    },
  },
};
</script>
